export default class WorkPlanParametrizationListCtrl {
  constructor ($scope, $resource, WorkPlanParametrizationSrv, uiGridConstants, $rootScope, $interval, $mdDialog) {
  // Constants
    const parametrizationListVM = this
  // Methods
    parametrizationListVM.showModalCreateWorkplan = showModalCreateWorkplan

    $rootScope.fullscreenClass = 'background-planning'
  // Grid definition
    parametrizationListVM.gridOptions = {
      columnDefs: [
        {          
          name: 'Nombre del plan de trabajo',
          displayName: 'Nombre del plan de trabajo',
          field: 'ds_name',
          width: '25%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {          
          name: 'Período',
          displayName: 'Período',
          field: 'periodicity_name',
          width: '15%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {          
          name: 'Fecha inicio',
          displayName: 'Fecha inicio',
          field: 'dt_startdate',
          width: '12%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: true,
          sort: { direction: uiGridConstants.DESC },
          cellFilter: "date: 'dd/MM/yyyy': 'UTC'"
        }, {
          name: 'Fecha fin',
          displayName: 'Fecha fin',
          field: 'dt_enddate',
          width: '12%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          cellFilter: "date: 'dd/MM/yyyy': 'UTC'"
        }, {
          name: 'Estado',
          displayName: 'Estado',          
          field: 'state_name',
          width: '20%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          name: 'Acciones',
          displayName: 'Acciones',
          field: 'id_state',
          width: '15%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          headerCellClass: 'column-center',
          cellTemplate: require('./cellTemplateWorkPlanActions.html')
        }
      ],
      sortInfo: {fields: ['dt_startdate'], directions: ['desc']},
      onRegisterApi: (gridApi) => {
        parametrizationListVM.gridApi = gridApi
        $interval(function () {
          parametrizationListVM.gridApi.core.handleWindowResize()
        }, 500, 10)
      }
    }
  // Method definitions
    function activate () {
      return getListItems()
    }

    function getListItems () {
      WorkPlanParametrizationSrv.getWorkPlans.get().$promise.then((dataReturn) => {
        if (dataReturn.status === true) {
          parametrizationListVM.gridOptions.data = dataReturn.data
        } else {
          console.log(dataReturn)
        }
      }).catch((err) => {
        console.log('Error: ', err)
      })
    }

    function showModalCreateWorkplan () {
      $mdDialog.show({
        template: require('../../../../layout/modal-create-workplan.html'),
        controller: 'workPlanCreateModalCtrl',
        clickOutsideToClose: true,
        fullscreen: parametrizationListVM.customFullscreen
      })
    }
  // Initialization
    activate()
  }
}

WorkPlanParametrizationListCtrl.$inject = ['$scope', '$resource', 'WorkPlanParametrizationSrv', 'uiGridConstants', '$rootScope', '$interval', '$mdDialog']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workPlanParametrization/list/workPlanParametrizationListCtrl.js